// @ts-nocheck
import React from 'react';
import { supabase } from '../utils/supabaseClient';
import { useToast } from './ToastProvider';

export default function ListPicker({ videoId, onClose, onAdded }: { videoId: string; onClose: ()=>void; onAdded?: ()=>void }) {
  const [lists, setLists] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [creating, setCreating] = React.useState(false);
  const [newName, setNewName] = React.useState('');
  const { toast } = useToast();

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
  const { data, error } = await supabase.from('video_lists').select('*', { count: 'none' }).order('created_at', { ascending: false });
        if (error) throw error;
        if (mounted) setLists(data || []);
      } catch (e:any) {
        toast(`No se pudieron cargar tus listas: ${e.message || 'desconocido'}`, 'error');
      } finally { if (mounted) setLoading(false); }
    })();
    return () => { mounted = false; };
  }, []);

  const addTo = async (listId: string) => {
    try {
      if (!videoId) throw new Error('Sin ID de video');
      const { error } = await supabase.from('list_videos').insert([{ list_id: listId, video_id: videoId }]);
      if (error) throw error;
      toast('Añadido a la lista.', 'success');
  onAdded?.();
      onClose();
    } catch (e:any) {
      toast(`No se pudo añadir: ${e.message || 'desconocido'}`, 'error');
    }
  };

  const createList = async () => {
    if (!newName.trim()) return;
    setCreating(true);
    try {
      const { data, error } = await supabase.from('video_lists').insert([{ name: newName.trim() }]).select().single();
      if (error) throw error;
      setLists((prev)=>[data, ...prev]);
      setNewName('');
    } catch (e:any) {
      toast(`No se pudo crear la lista: ${e.message || 'desconocido'}`, 'error');
    } finally { setCreating(false); }
  };

  return (
    <div className="absolute right-0 top-full mt-2 w-64 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg z-50">
      <div className="p-2">
        <div className="text-xs font-semibold text-gray-700 dark:text-gray-200 mb-2">Añadir a lista</div>
        <div className="flex gap-1 mb-2">
          <input value={newName} onChange={(e)=>setNewName(e.target.value)} placeholder="Nueva lista" className="flex-1 px-2 py-1 text-sm rounded border border-gray-300 dark:border-gray-700 bg-transparent" />
          <button disabled={creating} onClick={createList} className="px-2 py-1 text-xs rounded bg-gray-900 text-white disabled:opacity-50">Crear</button>
        </div>
        <div className="max-h-48 overflow-auto">
          {loading ? (
            <div className="text-xs text-gray-500 p-2">Cargando…</div>
          ) : lists.length ? (
            lists.map((l)=> (
              <button key={l.id} onClick={()=>addTo(l.id)} className="w-full text-left px-2 py-1.5 rounded hover:bg-gray-100 dark:hover:bg-gray-800 text-sm truncate">{l.name}</button>
            ))
          ) : (
            <div className="text-xs text-gray-500 p-2">No tienes listas aún.</div>
          )}
        </div>
        <div className="mt-2 flex justify-end"><button onClick={onClose} className="px-2 py-1 text-xs rounded border border-gray-300 dark:border-gray-700">Cerrar</button></div>
      </div>
    </div>
  );
}
